import classNames from "classnames/bind";
import styles from "./HeaderNavItems.module.scss";
import HeaderNavItemsList from "./HeaderNavItemsList";

import type { ResolvedNavItems } from "resolvers/base/navigationResolver";

const cx = classNames.bind(styles);

type HeaderNavItemProps = {
    navItems: ResolvedNavItems["mainMenu"];
    activeSubMenu: string | null;
    activeMegaMenu: string | null;
    handleToggleSubMenu: (key: string | null) => void;
    handleToggleMegaMenu: (key: string | null) => void;
    handleCancelToggleSubMenu: () => void;
    handleCancelToggleMegaMenu: () => void;
};

const HeaderNavItems = ({
    navItems,
    activeSubMenu,
    activeMegaMenu,
    handleToggleSubMenu,
    handleToggleMegaMenu,
    handleCancelToggleSubMenu,
    handleCancelToggleMegaMenu,
}: HeaderNavItemProps) => {
    return (
        <nav className={cx("navbar")}>
            <HeaderNavItemsList
                items={navItems.primary}
                activeSubMenu={activeSubMenu}
                activeMegaMenu={activeMegaMenu}
                handleToggleMegaMenu={handleToggleMegaMenu}
                handleToggleSubMenu={handleToggleSubMenu}
                handleCancelToggleSubMenu={handleCancelToggleSubMenu}
                priority="primary"
            />
            <HeaderNavItemsList
                items={navItems.secondary}
                activeSubMenu={activeSubMenu}
                activeMegaMenu={activeMegaMenu}
                handleToggleMegaMenu={handleToggleMegaMenu}
                handleToggleSubMenu={handleToggleSubMenu}
                handleCancelToggleMegaMenu={handleCancelToggleMegaMenu}
                priority="secondary"
            />
        </nav>
    );
};

export default HeaderNavItems;
